import { createAsyncThunk } from '@reduxjs/toolkit';
import { RulesAPI } from './RulesApi';

export const fetchAllRules = createAsyncThunk('rules/fetchAllRules', async () => {
  const response = await RulesAPI.fetchAllRules();
  return response.data;
});
